import React from 'react'

const TextHero = ({ centered }: { centered?: boolean }) => {
  return (
    <div className={['text-hero', centered && 'text-hero--centered'].join(' ')}>
      {/* In title, wrap words in span to make them red */}
      <h2 className='text-hero__title'>
        Find heat pump solutions for non-domestic building retrofits
      </h2>

      <p className='text-hero__text'>
        When you answer the questions, you will see a list of systems that are
        compatible with your responses and summaries of existing retrofits. You
        can click for more detailed information on each of the systems or
        example retrofits. If you can’t answer a question, you can skip it or
        explore how much difference a “yes” or “no” answer makes. If there is a
        difference you will need to make further enquiries or consult your
        supplier.
      </p>
    </div>
  )
}

export { TextHero }
